// extracted by mini-css-extract-plugin
module.exports =  {"validation-message":"Oy68VOL","validationMessage":"Oy68VOL","error":"IKKKgvg"};